import PropTypes from 'prop-types';
import { Skeleton } from 'antd';
import { HSCard } from './HSCard';

const SKELETON_CARD_STYLE = {
  height: '151px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '4px 20px',
};

export const HSCardSkeleton = ({ count = 1, className = '' }) =>
  Array.from({ length: count }, (_, index) => (
    <HSCard
      key={index}
      className={`item-container skeleton-container ${className}`.trim()}
      // Inline styles keep the layout consistent outside `.item-list-container` and override legacy `.skeleton-container` height.
      style={SKELETON_CARD_STYLE}
      content={
        <Skeleton
          active
          title={{ width: '100%' }}
          avatar={{ size: 60 }}
          paragraph={{ rows: 1, width: '50%' }}
        />
      }
    />
  ));

HSCardSkeleton.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string,
};

export default HSCardSkeleton;
